export default Object.freeze({
    SERBIA: 'Serbia',
    BOSNIA: 'Bosnia and Herzegovina',
})
